export default __webpack_public_path__ + "static/media/notification.d9bf2ae7.svg";